import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { chargily_payment } from "../store/reducers/paymentReducer";

const ChargilyPay = ({ paymentData }) => {
  const dispatch = useDispatch();
  const { url, loading, error } = useSelector((state) => state.payment);

  useEffect(() => {
    if (url && !loading) {
      window.open(url, "_blank"); // Open Chargily checkout URL in a new window
    }
  }, [url, loading]);

  const handlePayment = () => {
    dispatch(chargily_payment(paymentData));
  };

  return (
    <div>
      {loading && <p>Loading...</p>}
      {error && <p>Error: {error}</p>}
      {!url && !loading && (
        <button className="main-btn2" onClick={handlePayment}>
          Payer - ادفع الآن
        </button>
      )}
    </div>
  );
};

export default ChargilyPay;
